import type { PropsWithChildren } from 'react';
import '@/components/success-gambling/components/text/text.css';

export default function Text(props: PropsWithChildren) {
  const { children } = props;

  return <div className='success-gambling-text'>{children}</div>;
}
